import React, { useEffect } from "react";

const GetDiscount = () => {
  useEffect(() => {
    // Scroll to top when this page is rendered
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="container my-5">
      <h2
        className="text-center text-primary mb-5"
        style={{ fontSize: "2.5rem", fontWeight: "bold" }}
      >
        Get Discount and Become a Distributor
      </h2>

      <div className="row">
        {/* Bulk Order Discounts */}
        <div className="col-md-6 mb-4">
          <div
            className="card shadow-lg"
            style={{
              borderRadius: "15px",
              padding: "25px",
              backgroundColor: "#f4f9fd",
            }}
          >
            <div className="d-flex align-items-center mb-4">
              <i
                className="bi bi-tag-fill"
                style={{
                  fontSize: "35px",
                  color: "#FFC107",
                  marginRight: "15px",
                }}
              ></i>
              <h5
                className="card-title"
                style={{ fontSize: "1.3rem", fontWeight: "600" }}
              >
                Bulk Order Discounts
              </h5>
            </div>
            <p style={{ fontSize: "1rem", color: "#555" }}>
              Get amazing discounts when you buy in bulk! Perfect for events,
              schools, or businesses. Order now and save more.
            </p>
            <a href="/bulkorder" className="btn btn-primary mt-3">
              Place Order
            </a>
          </div>
        </div>

        {/* Become a Distributor */}
        <div className="col-md-6 mb-4">
          <div
            className="card shadow-lg"
            style={{
              borderRadius: "15px",
              padding: "25px",
              backgroundColor: "#f4f9fd",
            }}
          >
            <div className="d-flex align-items-center mb-4">
              <i
                className="bi bi-person-lines-fill"
                style={{
                  fontSize: "35px",
                  color: "#28a745",
                  marginRight: "15px",
                }}
              ></i>
              <h5
                className="card-title"
                style={{ fontSize: "1.3rem", fontWeight: "600" }}
              >
                Become a Distributor
              </h5>
            </div>
            <p style={{ fontSize: "1rem", color: "#555" }}>
              Join us as a distributor and grow with us. Enjoy great benefits,
              support, and opportunities to expand your business.
            </p>
            <a href="/distributor" className="btn btn-primary mt-3">
              Apply Now
            </a>
          </div>
        </div>

        {/* School/College/University Discount */}
        <div className="col-md-6 mb-4">
          <div
            className="card shadow-lg"
            style={{
              borderRadius: "15px",
              padding: "25px",
              backgroundColor: "#f4f9fd",
            }}
          >
            <div className="d-flex align-items-center mb-4">
              <i
                className="bi bi-house-door"
                style={{
                  fontSize: "35px",
                  color: "#007bff",
                  marginRight: "15px",
                }}
              ></i>
              <h5
                className="card-title"
                style={{ fontSize: "1.3rem", fontWeight: "600" }}
              >
                Schools, Colleges & Universities
              </h5>
            </div>
            <p style={{ fontSize: "1rem", color: "#555" }}>
              We offer special prices for schools and colleges. Keep your
              students and staff hydrated with our high-quality water.
            </p>
            <a href="/bulkorder" className="btn btn-primary mt-3">
              Place Order
            </a>
          </div>
        </div>

        {/* Hospital Discount */}
        <div className="col-md-6 mb-4">
          <div
            className="card shadow-lg"
            style={{
              borderRadius: "15px",
              padding: "25px",
              backgroundColor: "#f4f9fd",
            }}
          >
            <div className="d-flex align-items-center mb-4">
              <i
                className="bi bi-plus-circle"
                style={{
                  fontSize: "35px",
                  color: "#28a745",
                  marginRight: "15px",
                }}
              ></i>
              <h5
                className="card-title"
                style={{ fontSize: "1.3rem", fontWeight: "600" }}
              >
                Hospitals
              </h5>
            </div>
            <p style={{ fontSize: "1rem", color: "#555" }}>
              Special discounts for hospitals to ensure fresh drinking water for
              patients and staff.
            </p>
            <a href="/bulkorder" className="btn btn-primary mt-3">
              Place Order
            </a>
          </div>
        </div>

        {/* Hotel Discount */}
        <div className="col-md-6 mb-4">
          <div
            className="card shadow-lg"
            style={{
              borderRadius: "15px",
              padding: "25px",
              backgroundColor: "#f4f9fd",
            }}
          >
            <div className="d-flex align-items-center mb-4">
              <i
                className="bi bi-building"
                style={{
                  fontSize: "35px",
                  color: "#FF5722",
                  marginRight: "15px",
                }}
              ></i>
              <h5
                className="card-title"
                style={{ fontSize: "1.3rem", fontWeight: "600" }}
              >
                Hotels & Resorts
              </h5>
            </div>
            <p style={{ fontSize: "1rem", color: "#555" }}>
              Hotels and resorts get special prices. Provide your guests with
              the best drinking water experience.
            </p>
            <a href="/bulkorder" className="btn btn-primary mt-3">
              Place Order
            </a>
          </div>
        </div>

        {/* Regular Households Discount */}
        <div className="col-md-6 mb-4">
          <div
            className="card shadow-lg"
            style={{
              borderRadius: "15px",
              padding: "25px",
              backgroundColor: "#f4f9fd",
            }}
          >
            <div className="d-flex align-items-center mb-4">
              <i
                className="bi bi-house-door-fill"
                style={{
                  fontSize: "35px",
                  color: "#FFC107",
                  marginRight: "15px",
                }}
              ></i>
              <h5
                className="card-title"
                style={{ fontSize: "1.3rem", fontWeight: "600" }}
              >
                Regular Household Customers
              </h5>
            </div>
            <p style={{ fontSize: "1rem", color: "#555" }}>
              Regular customers enjoy great discounts on consistent orders. Get
              the best water for your family.
            </p>
            <a href="/bulkorder" className="btn btn-primary mt-3">
              Place Order
            </a>
          </div>
        </div>
        {/* NGO DISCOUNT */}
        <div className="col-md-6 mb-4">
          <div
            className="card shadow-lg"
            style={{
              borderRadius: "15px",
              padding: "25px",
              backgroundColor: "#f4f9fd",
            }}
          >
            <div className="d-flex align-items-center mb-4">
              <i
                className="bi bi-percent"
                style={{
                  fontSize: "35px",
                  color: "#007bff",
                  marginRight: "15px",
                }}
              ></i>
              <h5
                className="card-title"
                style={{ fontSize: "1.3rem", fontWeight: "600" }}
              >
                Special Discount For NGO's
              </h5>
            </div>
            <p style={{ fontSize: "1rem", color: "#555" }}>
              Get special discounts on bulk orders for your community or NGO.
              Support clean water initiatives at affordable prices!
            </p>
            <a href="/bulkorder" className="btn btn-primary mt-3">
              Place Order
            </a>
          </div>
        </div>
        {/* Sports Event */}
        <div className="col-md-6 mb-4">
          <div
            className="card shadow-lg"
            style={{
              borderRadius: "15px",
              padding: "25px",
              backgroundColor: "#f4f9fd",
            }}
          >
            <div className="d-flex align-items-center mb-4">
              <i
                className="bi bi-trophy"
                style={{
                  fontSize: "35px",
                  color: "#007bff",
                  marginRight: "15px",
                }}
              ></i>
              <h5
                className="card-title"
                style={{ fontSize: "1.3rem", fontWeight: "600" }}
              >
                Sports Event Special
              </h5>
            </div>
            <p style={{ fontSize: "1rem", color: "#555" }}>
              Get bottled water for your sports event with special discounts.
              Keep your players hydrated and refreshed throughout!
            </p>
            <a href="/bulkorder" className="btn btn-primary mt-3">
              Place Order
            </a>
          </div>
        </div>

        {/* Free Shipping Option */}
        <div className="col-md-6 mb-4">
          <div
            className="card shadow-lg"
            style={{
              borderRadius: "15px",
              padding: "25px",
              backgroundColor: "#f4f9fd",
            }}
          >
            <div className="d-flex align-items-center mb-4">
              <i
                className="bi bi-truck"
                style={{
                  fontSize: "35px",
                  color: "#007bff",
                  marginRight: "15px",
                }}
              ></i>
              <h5
                className="card-title"
                style={{ fontSize: "1.3rem", fontWeight: "600" }}
              >
                Free Shipping
              </h5>
            </div>
            <p style={{ fontSize: "1rem", color: "#555" }}>
              Free delivery on large orders! Get your water delivered safely and
              on time.
            </p>
            <a href="/bulkorder" className="btn btn-primary mt-3">
              Place Order
            </a>
          </div>
        </div>
      </div>

      {/* Additional Content */}
      <div className="text-center mt-5">
        <h3 className="text-primary">Why Choose NGO Waters?</h3>
        <p className="lead">
          With NGO Waters, you get quality drinking water, great deals, and
          excellent service. Join us and make a difference today!
        </p>
      </div>
    </div>
  );
};

export default GetDiscount;
